/* eslint-disable */
export default {
  add: 'Añadir',
  noCalls: 'No hay llamadas disponibles',
  activeCall: 'Llamada activa',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
